/* eslint-disable no-restricted-globals */
/* eslint-disable eqeqeq */
import { ERROR_HANDLING_EXPERIENCE, HTTP_CODE } from '../../utils/redirector-utils';

export const isInvalidReviewsCanonical = ({ data, path, pageNumber }) => {
  const { canonicalUrl } = data?.product?.identifiers || {};

  if (canonicalUrl) {
    const page = pageNumber ? `/${pageNumber}` : '/1';

    const canonicalUrlWithContext = canonicalUrl?.replace('/p/', '/p/reviews/').concat(page);

    if (path !== canonicalUrlWithContext && path !== encodeURI(canonicalUrlWithContext)) {
      return {
        shouldRedirect: true,
        httpCode: HTTP_CODE.PERM_REDIRECT,
        redirectPath: canonicalUrlWithContext,
        description: 'redirected for canonical'
      };
    }
  }

  return null;
};

export function isInvalidPageNumber({ data, pageNumber }) {
  if (isNaN(pageNumber) || pageNumber < 1) {
    return {
      shouldRedirect: false,
      isErrorStatus: true,
      httpCode: HTTP_CODE.NOT_FOUND,
      description: `${pageNumber} is not a valid page number`,
      errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.PRODUCT
    };
  }

  if (data?.reviews) {
    const results = data?.reviews?.Results || [];
    if (pageNumber != 1 && results.length === 0) {
      return {
        shouldRedirect: false,
        isErrorStatus: true,
        httpCode: HTTP_CODE.NOT_FOUND,
        description: `Results for page number ${pageNumber} not found`,
        errorHandlingExperience: ERROR_HANDLING_EXPERIENCE.PRODUCT
      };
    }
  }

  return null;
}
